import { getAccount, selectAccount } from "app/redux/accountSlice";
import { useQuery } from "app/utils/useQuery";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

export const useCanceledBooking = () => {
  const dispatch = useDispatch();
  const { nameKey } = useParams();
  const account = useSelector(selectAccount);
  const navigate = useNavigate();
  const query = useQuery();

  const onReschedulePress = () => {
    // A fresh booking: the cancelled one's refund details don't come along
    navigate(`/book/${nameKey}?reschedule=true`);
  };

  useEffect(() => {
    (async () => {
      if (!nameKey) {
        return navigate("/");
      }
      if (!account.id) {
        try {
          await dispatch(getAccount({ nameKey }) as any).unwrap();
        } catch (error) {
          navigate("/");
          console.log("error", error);
        }
      }
    })();
  }, []);

  // Set by the manage page after a cancel: whether what the client paid was refunded
  const refund = {
    status: query.get("refund"),
    cents: Number(query.get("refundCents") || 0),
  };

  return {
    account,
    onReschedulePress,
    refund,
  };
};
